export default __webpack_public_path__ + "static/media/CoverFramed.14e0e9b1.jpg";